module.exports = __webpack_public_path__ + "img/chuanbi.f6a4ad05.png";